// Soft Petal Electrolysis, single source of truth for editable content
// Update business details, services, pricing, testimonials, and policies here.

export const business = {
  name: "Soft Petal Electrolysis",
  tagline: "Where smoothness blooms and confidence blossoms.",
  city: "Garden City",
  state: "NY",
  address: "400 Garden City Plaza Ste 110 Room 16, Garden City, NY 11530",
  phone: "516-696-0925",
  phoneHref: "tel:+15166960925",
  email: "Genesis@softpetalelectrolysis.com",
  emailHref: "mailto:Genesis@softpetalelectrolysis.com",
  hours: [
    { day: "Sunday", value: "9:00 AM to 4:00 PM" },
    { day: "Monday", value: "9:00 AM to 4:00 PM" },
    { day: "Tuesday", value: "9:00 AM to 4:00 PM" },
    { day: "Wednesday", value: "9:00 AM to 9:00 PM" },
    { day: "Thursday", value: "9:00 AM to 4:00 PM" },
    { day: "Friday", value: "9:00 AM to 3:00 PM" },
    { day: "Saturday", value: "9:00 AM to 2:00 PM" },
  ],
  bookingUrl: "https://app.squareup.com/appointments/book/LJG1W3DS6QGHY",
  social: {
    instagram: "https://www.instagram.com/soft.petal.electrolysis",
    facebook: "https://facebook.com/",
    tiktok: "https://tiktok.com/",
    google: "https://www.google.com/search?q=soft+petal+electrolysis+llc#lrd=0x89c27d17ecd3c329:0xdb7895df8dfddf07,1",
    googleMaps: "https://maps.google.com/?cid=15814499573486825735",
  },
  announcement: {
    enabled: true,
    text: "Now welcoming new Soft Petal Pals. Book your consultation today.",
  },
};

export const images = {
  hero: "https://customer-assets-39nsmqrw.emergentagent.net/job_softpetal-build/artifacts/gwr7xbmi_9063da3e-2bd5-467a-8786-79a2e639001d.png",
  founder: "https://customer-assets-wrfwihn1.emergentagent.net/job_6c0240eb-b10e-4d80-9ab4-d4469d77d491/artifacts/3rxk3au5_unnamed-2.jpg",
  serviceFacial: "https://customer-assets-39nsmqrw.emergentagent.net/job_softpetal-build/artifacts/gkxs918h_unnamed-1.png",
  serviceBody: "https://customer-assets-39nsmqrw.emergentagent.net/job_softpetal-build/artifacts/dmcqvs0i_unnamed.png",
  serviceConsult: "https://customer-assets-39nsmqrw.emergentagent.net/job_softpetal-build/artifacts/1db2wvjb_unnamed-1.png",
  servicePlan: "https://customer-assets-39nsmqrw.emergentagent.net/job_softpetal-build/artifacts/0sgmcu01_unnamed-2.png",
  spaLilies: "https://images.pexels.com/photos/37903358/pexels-photo-37903358.jpeg?auto=compress&cs=tinysrgb&w=1400",
  inclusiveSkin: "https://customer-assets-39nsmqrw.emergentagent.net/job_softpetal-build/artifacts/zwyde4wm_unnamed.jpg",
  diploma: "https://customer-assets-39nsmqrw.emergentagent.net/job_softpetal-build/artifacts/rxsezws4_unnamed-1.jpg",
  ogShare: "/og-share.jpg",
  apilus: "https://customer-assets-39nsmqrw.emergentagent.net/job_softpetal-build/artifacts/fj9eyl5s_unnamed.jpg",
  servicesIntro: "https://customer-assets-39nsmqrw.emergentagent.net/job_softpetal-build/artifacts/i84g9n9a_unnamed-1.jpg",
};

export const services = [
  {
    slug: "consultation",
    title: "Complimentary Consultation",
    duration: "New clients",
    price: "Complimentary",
    priceNote: "Free first visit",
    description:
      "A warm, unhurried conversation to understand your goals, review your skin and hair, and design a treatment plan that feels right for you.",
    image: "serviceConsult",
  },
  {
    slug: "facial",
    title: "Facial Electrolysis",
    duration: "10 to 60 minutes",
    price: "From $45",
    priceNote: "Starting at 10 min",
    description:
      "Precise permanent hair removal for the upper lip, chin, jawline, cheeks, sideburns, and brow. Gentle, focused, and refined.",
    image: "serviceFacial",
  },
  {
    slug: "body",
    title: "Body Electrolysis",
    duration: "10 to 60 minutes",
    price: "From $45",
    priceNote: "Starting at 10 min",
    description:
      "Permanent hair removal for underarms, bikini, stomach, back, chest, fingers, toes, and more, designed around your comfort.",
    image: "serviceBody",
  },
  {
    slug: "plans",
    title: "Session Packages",
    duration: "5, 10, or 15 sessions",
    price: "Save up to $175",
    priceNote: "Best value",
    description:
      "Save more when you commit to your journey. Choose 5, 10, or 15-session packages tailored to your session length and goals.",
    image: "servicePlan",
  },
];

export const trustBenefits = [
  {
    title: "Safe & Effective",
    copy: "Clinically established electrolysis treatments performed with care and precision.",
  },
  {
    title: "All Skin Tones",
    copy: "Personalized treatment plans for every complexion and hair texture.",
  },
  {
    title: "Expert Care",
    copy: "Professional service delivered in a warm, respectful environment.",
  },
  {
    title: "Lasting Results",
    copy: "A permanent hair-removal solution designed around your goals.",
  },
];

export const pricing = [
  { label: "10-Minute Session", duration: "10 min", price: "$45" },
  { label: "15-Minute Session", duration: "15 min", price: "$50" },
  { label: "30-Minute Session", duration: "30 min", price: "$70" },
  { label: "45-Minute Session", duration: "45 min", price: "$90" },
  { label: "60-Minute Session", duration: "60 min", price: "$110" },
  { label: "Complimentary Consultation", duration: "New clients", price: "Complimentary" },
];

export const packages = {
  headers: ["Session Length", "Single Session", "5-Session Package", "10-Session Package", "15-Session Package"],
  rows: [
    { length: "10 Minutes", single: "$45",  five: "$215",  fiveSave: "save $10",  ten: "$400",   tenSave: "save $50",  fifteen: "$585",   fifteenSave: "save $90"  },
    { length: "15 Minutes", single: "$50",  five: "$235",  fiveSave: "save $15",  ten: "$450",   tenSave: "save $50",  fifteen: "$645",   fifteenSave: "save $105" },
    { length: "30 Minutes", single: "$70",  five: "$330",  fiveSave: "save $20",  ten: "$650",   tenSave: "save $50",  fifteen: "$925",   fifteenSave: "save $125" },
    { length: "45 Minutes", single: "$90",  five: "$425",  fiveSave: "save $25",  ten: "$850",   tenSave: "save $50",  fifteen: "$1,225", fifteenSave: "save $125" },
    { length: "60 Minutes", single: "$110", five: "$520",  fiveSave: "save $30",  ten: "$1,030", tenSave: "save $70",  fifteen: "$1,475", fifteenSave: "save $175" },
  ],
  notes: [
    "Credit card fees apply",
    "Tips are appreciated",
  ],
};

export const policies = [
  {
    title: "Non-Transferable",
    copy: "Packages are for individual use only and cannot be shared or transferred.",
  },
  {
    title: "No-Show Policy",
    copy: "If you miss a scheduled session without 24 hour prior notice, it will be counted as completed, and no makeup session will be provided.",
  },
  {
    title: "Non-Refundable",
    copy: "All packages are non-refundable. Please ensure commitment to the package terms before purchasing.",
  },
  {
    title: "Cancellation & Late Arrival",
    copy: "We kindly ask for at least 24 hours' notice for changes. Late arrivals will be treated within the remaining session time, and full session pricing applies.",
  },
];

// Verified Google reviews for Soft Petal Electrolysis
export const testimonials = [
  {
    quote:
      "I cannot say enough great things about my electrolysis treatments! I felt right at home from my very first appointment. The atmosphere was aesthetically inviting and clean. My technician Genesis was so professional, easy to talk to and ensured my comfort was priority. She took the time to walk me through every step of the process and made sure all my questions were answered. Thank you Genesis for being so kind. I am grateful to you and your attention to detail during my treatments.",
    name: "Paula Donaldson",
    rating: 5,
    date: "4 days ago",
    source: "Google",
  },
  {
    quote:
      "Genesis is professional, knowledgeable, and kind. She made me feel comfortable throughout the entire process and took the time to answer all of my questions. She does great work. I would recommend her to anyone!",
    name: "Adriana Sevilla",
    rating: 5,
    date: "1 week ago",
    source: "Google",
  },
  {
    quote:
      "Genesis did an amazing job. I had a really amazing experience. It was a very welcoming environment and I highly recommend it!",
    name: "Faith Koiki",
    rating: 5,
    date: "2 days ago",
    source: "Google",
  },
  {
    quote:
      "This young lady is knowledgeable. Highly recommend. Clean space. She helped me perfect my beard line. I'm definitely using her services again!",
    name: "Luke McBosch",
    rating: 5,
    date: "1 week ago",
    source: "Google",
  },
];

export const faqs = [
  {
    q: "What is electrolysis?",
    a: "Electrolysis is a method of permanent hair removal that treats individual hair follicles using a fine, sterile probe and a small amount of electrical current to disable future hair growth.",
  },
  {
    q: "Is electrolysis permanent?",
    a: "Electrolysis is currently the only FDA-recognized method of permanent hair removal. Results build over a series of appointments as follicles are treated across their growth cycles.",
  },
  {
    q: "Does electrolysis work on every skin tone?",
    a: "Yes. Electrolysis is suitable for all skin tones because it does not rely on pigment contrast, it targets the follicle itself.",
  },
  {
    q: "Can electrolysis treat every hair color?",
    a: "Yes. Unlike laser, electrolysis works on light, dark, red, gray, and white hair, and across a wide range of hair textures.",
  },
  {
    q: "What areas can be treated?",
    a: "Common areas include upper lip, chin, jawline, cheeks, brows, sideburns, underarms, bikini, stomach, back, chest, fingers, and toes. Your consultation will help identify what's right for you.",
  },
  {
    q: "How many appointments will I need?",
    a: "Because hair grows in cycles, most areas need a series of appointments over time. Your electrologist will outline a personalized plan based on your area, density, and goals.",
  },
  {
    q: "How long does each appointment take?",
    a: "Sessions typically run from 15 to 60 minutes. Longer sessions may be scheduled for larger areas.",
  },
  {
    q: "What does electrolysis feel like?",
    a: "Sensation varies by person and area, many describe it as a quick warm pinch. Comfort is a priority, and pacing is adjusted to your tolerance.",
  },
  {
    q: "How should I prepare for my appointment?",
    a: "Arrive with clean, product-free skin in the treatment area. Stay well hydrated and avoid excessive sun exposure the day of your appointment.",
  },
  {
    q: "Should I stop tweezing or waxing?",
    a: "Yes, please avoid tweezing, waxing, threading, or any hair removal method that pulls from the root before and during your electrolysis journey.",
  },
  {
    q: "Can I shave between appointments?",
    a: "Yes. Shaving is completely fine and will not affect your treatment progress.",
  },
  {
    q: "What should I expect after treatment?",
    a: "Some temporary redness, mild swelling, or tiny raised bumps are normal and typically settle within a few hours to a day.",
  },
  {
    q: "Is temporary redness normal?",
    a: "Yes. Temporary redness is a normal response and usually resolves quickly with gentle aftercare.",
  },
  {
    q: "Can I wear makeup after facial electrolysis?",
    a: "It is best to avoid makeup on treated areas for the remainder of the day so the skin can settle undisturbed.",
  },
  {
    q: "How do I book a consultation?",
    a: "Use the Book Now button on any page, or send a message through the Contact page and we will follow up with next steps.",
  },
  {
    q: "What is your cancellation policy?",
    a: "We kindly ask for at least 24 hours' notice for changes so we can offer your time to another client.",
  },
  {
    q: "Is your space inclusive and judgment-free?",
    a: "Absolutely. Soft Petal Electrolysis welcomes every person, regardless of background, skin tone, gender identity, or personal story.",
  },
  {
    q: "How is equipment cleaned and sterilized?",
    a: "We follow strict sanitation standards. All probes are single-use and disposed of after each client, and treatment surfaces are disinfected between appointments.",
  },
];

export const nav = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/technology", label: "Technology" },
  { to: "/pricing", label: "Pricing" },
  { to: "/reviews", label: "Reviews" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];
